export const arrayToOpts = (array) =>
  array.map((element, index) => {
    return { key: index, value: index, text: element };
  });
